import { createContext, ReactNode, useCallback, useContext, useState } from 'react'
import { InferFormValues, JsonFormSchemaV2 } from '../components/component-library/FormComponent/types'

interface TileFiltersContextType {
  tileFilterSelections: Record<string, unknown>[]
  filterChangeHandler: (data: InferFormValues<JsonFormSchemaV2>) => void
}

const TileFiltersContext = createContext<TileFiltersContextType | undefined>(undefined)

export function TileFiltersProvider({
  children,
  initialSelections = [],
  allowChanges = true,
}: {
  children: ReactNode
  initialSelections?: Record<string, unknown>[]
  allowChanges?: boolean
}) {
  const [tileFilterSelections, setTileFilterSelections] = useState<Record<string, unknown>[]>(initialSelections)

  const filterChangeHandler = useCallback(
    (data: InferFormValues<JsonFormSchemaV2>) => {
      if (!allowChanges) return

      setTileFilterSelections(
        Object.entries(data).map(([key, value]) => ({
          [key]: value,
        }))
      )
    },
    [allowChanges]
  )

  return (
    <TileFiltersContext.Provider value={{ tileFilterSelections, filterChangeHandler }}>
      {children}
    </TileFiltersContext.Provider>
  )
}

export function useTileFilters() {
  const context = useContext(TileFiltersContext)
  if (context === undefined) {
    throw new Error('useTileFilters must be used within a TileFiltersProvider')
  }
  return context
}
